import LineInterface from 'app/interfaces/LineInterface';

export const hasNestedLines = (line: LineInterface): boolean => line.active_nested_bets_count > 0;
